var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"offset-lg-3 style-paper col-lg-6 text-center"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('div',{attrs:{"id":"content"}},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }